"use client";

import ProductModalAddress from "@/app/products/[...handle]/_components/productDetail/_components/productModalAddress/ProductModalAddress";
import React, { useEffect, useState } from "react";
import StoreIcon from "@/components/icons/StoreIcon";
import { ProductJson } from "@/types/Product.type";

import PopupV2 from "@/components/PopupV2";
import useTranslationApi from "@/lib/hooks/useTranslationApi";
import { useAppSelector } from "@/redux/hook";

const translate = {
	product_store_near_you: "product_store_near_you",
	product_view_store: "product_view_store",
	product_stores_namperfume: "product_stores_namperfume",
};

export default function StoreList({ product }: { product: ProductJson }) {
	const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
	const { t } = useTranslationApi(Object.values(translate));
	const device = useAppSelector((state) => state.ShopReducer.device);




	return (
		<>
			<div
				className="flex items-center gap-1 cursor-pointer w-fit"
				onClick={() => setIsOpenModal(true)}>
				<StoreIcon className="text-blue-main  w-[14px] h-[14px] min-w-[14px]" />
				<span className="text-blue-main  text-sm leading-[1.6] hidden md:inline">
					{/* Cửa hàng gần bạn */}
					{t(translate.product_store_near_you)}
				</span>
				<span className="text-blue-main  text-sm leading-[1.6] md:hidden ">
					{/* Xem chi nhánh còn hàng / mẫu thử */}
					{t(translate.product_view_store)}
				</span>
			</div>
			<PopupV2
				open={isOpenModal}
				onOpenChange={() => {
					setIsOpenModal(false);
				}}
				classNameTitle=" md:text-lg text-base font-bold"
				title={t(translate.product_stores_namperfume)}
				classNameContent=" h-[540px] md:h-[680px] w-full md:w-[500px] px-0 rounded-sm py-0 py-4  overflow-hidden"
				animate={device === "desktop" ? "tran" : "tran-up"}
				// isDrawerMobile

				classNameDrawerMobile="h-[70vh]">
				<ProductModalAddress product={product} />
			</PopupV2>
		</>
	);
}
